enum LocalStorageItemNamesEnum {
    DesignFilters = 'designFilters',
    DesignSearch = 'designSearch',
    ModelFilters = 'modelFilters',
    ModelSearch = 'modelSearch',
    EstimateFilters = 'estimateFilters',
    EstimateListActsFilters = 'estimateListActsFilters',
    EstimateKs6Filters = 'estimateKs6Filters',
    TaskFilters = 'taskFilters',
    ChartFilters = 'chartFilters',
    ChartSearch = 'chartSearch',
    ReportFilters = 'reportFilters',
    DpcExecFilters = 'dpcExecFilters',
    DpcExecSearch = 'dpcExecSearch',
}

export default LocalStorageItemNamesEnum;
